import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtGetProductManagerListForSelect(params) {
  return request(`${BASE_URL}/provider/ams/user/listpdset`, METHOD.GET, params)
}
